require('../partials/hubSpecificStyles/_it.scss');
const hubSpecificJS = require('../scriptPartials/hubSpecificFunctions/_italian.js');
const onbrandScripts = require('../onbrand.js');

//only use if there are descrepencies between different language sites.
const generateLinks = (arr) => {
  return arr.map((link) => `<a href="${link.href}" id="${link.id}">${link.label}</a>`).join('');
};

const translations = {
  header: {},
  footer: {},
  home: "Home",
};

hubSpecificJS();
onbrandScripts.initOnbrand(translations, production);



// WEBPACK FOOTER //
// ./entryPoints/it.js